import React from "react";
import { withRouter } from "react-router-dom";
import * as GC from "../../common/common";
import $ from "jquery";

class TreeChildren extends React.Component {
  constructor(props) {
    super(props);
    this.handleCheck = this.handleCheck.bind(this);
    this.handleEvent = this.handleEvent.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.state = {
      TreeList: props.TreeList,
      componentName: props.componentName,
      pathname: props.pathname,
      treeLocation: props.treeLocation,
      activeIndex: 0,
      pureTree: props.pureTree,
    };
  }
  handleEvent() {
    this.state = {
      TreeList: this.props.TreeList,
      componentName: this.props.componentName,
      treeLocation: this.props.treeLocation,
      pathname: this.props.pathname,
      activeIndex: 0,
      pureTree: this.props.pureTree,
    };
  }

  handleCheck(index, id, e) {
    document
      .getElementById("tree-parent-id")
      .setAttribute("value", id /*e.currentTarget.dataset.id*/);
    this.setState({ activeIndex: index });
    e.stopPropagation();

    this.props.history.push(
      "/" + this.state.pathname + "/" + this.state.componentName,
      id != null
        ? {
            componentName: this.state.componentName,
            treeLocation: this.state.treeLocation,
            id: id /*e.currentTarget.dataset.id*/,
            TreeList: this.state.TreeList,
            isDidUpdate: id /* e.currentTarget.dataset.id*/,
          }
        : {
            isDidUpdate: "0038",
          }
    );
  }

  async handleClick(index, e) {
    var that = this;
    var lastSubFolderId;
    var lastParentFolderId;
    var allClose = 0;
    var clickList = GC.TreeResolve(that.state.TreeList);

    var target = e.target;
    // modalda açılan tree'lerin veri getirmemesi için kullanılıyor.
    if (target.attributes["name"].value != "modal") {
      that.handleCheck(target.dataset.id, target.dataset.id, e);
    }
    document
      .getElementById("tree-parent-id")
      .setAttribute("value", e.currentTarget.dataset.id);
    e.stopPropagation();
    e.preventDefault();
    clickList.forEach((element) => {
      if (element.id == target.dataset.id) {
        element.isOpen = !element.isOpen;
        if (element.isSubfolder == false) {
          lastSubFolderId = element.id;
        }
        if (!element.isOpen) {
          clickList.forEach((lastParentFolder) => {
            if (lastParentFolder.id == element.parentfolder) {
              lastParentFolder.isOpen = true;
              lastParentFolderId = lastParentFolder.id;
              /**
               * ? eğer ağaç dalı kapalı ise yanı parent folderdan veri
               * ? veri çekilecekse burada main fonksisyona parent id'si gönderilmelidir.
               */
              // modalda açılan tree'lerin veri getirmemesi için kullanılıyor.
              if (target.attributes["name"].value != "modal") {
                that.handleCheck(lastParentFolderId, lastParentFolderId, e);
              }
            }
          });
        }
      } else {
        if (element.id != lastSubFolderId && element.id != lastParentFolderId) {
          element.isOpen = false;
        }
      }
    });

    var elementDiv = e.target.classList;
    var element = e.target.parentElement;
    var parent = element.parentElement;
    var opensubs = parent.querySelectorAll(":scope .open.act");
    var classList = element.classList;

    if (opensubs.length !== 0) {
      for (var i = 0; i < opensubs.length; i++) {
        opensubs[i].classList.remove("open");
        opensubs[i].classList.remove("act");
      }
    }
    clickList.forEach((element) => {
      if (element.id == target.dataset.id && element.isOpen == true) {
        classList.add("open");
        classList.add("act");

        elementDiv.add("open");
        elementDiv.add("act");
      }
    });
    var opensubsAll = await document.querySelectorAll(":scope .open.act");
    if (opensubsAll.length == 0) {
      // modalda açılan tree'lerin veri getirmemesi için kullanılıyor.
      if (target.attributes["name"].value != "modal") {
        that.handleCheck(null, null, e);
      }
    }
  }
  componentDidUpdate(prevProps, prevState) {
    // eğer main-tab'a tıklanılmışsa "Beheereenheden" tüm ağaç sıfırlanır.
    if (this.props.location.isDidUpdate === "0038") {
      this.props.TreeList.forEach((item) => {
        item.isOpen = false;
      });
    }
  }
  componentDidMount() {}
  inputProps = [];
  Tree = (data) => {
    if (this.state.treeLocation == "modal") {
      this.inputProps = {
        name: "modal",
      };
    } else
      this.inputProps = {
        name: "side-tree",
      };
    return (
      <ul className="tree">
        {data &&
          data.map((item) => (
            <li
              key={item.id.toString()}
              data-id={item.id}
              onClick={this.handleClick.bind(this, item.id)}
              {...this.inputProps}
            >
              <div
                data-id={item.id}
                className={
                  item.children && item.children.length > 0
                    ? "has-child"
                    : "" || item.treeSymbolType === "rombus"
                    ? "rombus"
                    : ""
                }
                {...this.inputProps}
              >
                {item.name}{" "}
              </div>
              {item.children && item.children.length > 0
                ? this.Tree(item.children)
                : ""}
            </li>
          ))}
      </ul>
    );
  };

  render() {
    this.handleEvent();
    return (
      <div>
        {this.Tree(
          this.state.TreeList,
          this.state.componentName,
          this.state.pathname,
          this.state.treeLocation
        )}
      </div>
    );
  }
}

export default withRouter(TreeChildren);
